import { Link } from "@tanstack/react-router";
import type React from "react";
import { AppToggle } from "@/components/navigation/AppToggle";
import { UserIconMenu } from "@/components/navigation/UserIconMenu";
import { useGlobalUserInfo } from "@/providers/AuthProvider";

export const Navbar: React.FC = () => {
  const userInfo = useGlobalUserInfo();

  return (
    <nav className="fixed inset-x-0 top-0 z-50 h-[60px] bg-rw-sub">
      <div className="flex h-full flex-1 items-center justify-center px-4">
        {/* Left section */}
        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 transition-opacity hover:opacity-80"
            aria-label="Go to home page"
          >
            <img src="/logo-white.png" alt="logo" className="h-8" />
          </Link>
        </div>

        {/* Spacer to push right content to the right */}
        <div className="flex-1" />

        {/* Right section */}
        <div className="flex items-center justify-center gap-3">
          <AppToggle />

          <UserIconMenu
            displayUsername={userInfo?.display_name}
            profileImageUrl={userInfo?.image_url}
          />
        </div>
      </div>
    </nav>
  );
};
